import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SurgeonOpeningsDal } from '../dal/surgeon-openings.dal';
import { Profile } from '../models/profile.model';
import { SurgeonOpening } from '../models/surgeonOpenings.model';

@Injectable({
  providedIn: 'root',
})
export class SurgeonOpeningsService {
  constructor(private surgeonOpeningsDal: SurgeonOpeningsDal) {}

  getAllSOByWeek(
    startDate: string,
    endDate: string,
    specialties?: string,
    scenario?: string,
    campaign?: string
  ): Observable<Profile[]> {
    return this.surgeonOpeningsDal.getAllSOByWeek(startDate, endDate, specialties, scenario, campaign);
  }

  getSurgeons(_id: string, date: string): Observable<Profile[]> {
    return this.surgeonOpeningsDal.getSurgeons(_id, date);
  }

  getSurRHRec(profileId: string, startDate: string, endDate: string): Observable<any> {
    return this.surgeonOpeningsDal.getSurRHRec(profileId, startDate, endDate);
  }

  updateSimpleDayNeeds(surgeonOpenings: any, isTvo: boolean = false): Observable<any> {
    return this.surgeonOpeningsDal.updateSimpleDayNeeds(surgeonOpenings, isTvo);
  }

  getWeekOpenings(surgeonId: string, date: string): Observable<SurgeonOpening[]> {
    return this.surgeonOpeningsDal.getWeekOpenings(surgeonId, date);
  }

  getProfilesOpenings(surgeonsIds: string[], fromDate: string | Date, toDate: string | Date, delay: number = 0) {
    const from: string = new Date(fromDate).toISOString();
    const to: string = new Date(toDate).toISOString();
    const body = { profiles: surgeonsIds };

    return timer(delay).pipe(switchMap(() => this.surgeonOpeningsDal.getProfilesOpenings(from, to, body)));
  }

  updateManySO(profile: Profile, fromDate: string, toDate: string, body: any): Observable<SurgeonOpening[]> {
    return this.surgeonOpeningsDal.updateManySO(profile, fromDate, toDate, body);
  }

  getNeeds(date: string): Observable<any> {
    return this.surgeonOpeningsDal.getNeeds(date);
  }

  modifySurgeonOpeningNeed(surgeonOpeningId: string, needs: any): Observable<any[]> {
    return this.surgeonOpeningsDal.modifySurgeonOpeningNeed(surgeonOpeningId, needs);
  }

  checkExistence(startDate: string, endDate: string, concernedRooms: any): Observable<any[]> {
    return this.surgeonOpeningsDal.checkExistence(startDate, endDate, concernedRooms);
  }

  saveSchedulingPDF(
    schedulingData: any,
    weekDays: any,
    formationsGroups: any,
    roomsName: any,
    displayCodes: boolean,
    showRoles?: boolean,
    isBasicService?: boolean,
    reverseNameOrder?: boolean,
    showRMColor?: boolean
  ): Observable<Blob> {
    return this.surgeonOpeningsDal.saveSchedulingPDF(
      schedulingData,
      weekDays,
      formationsGroups,
      roomsName,
      displayCodes,
      showRoles,
      isBasicService,
      reverseNameOrder,
      showRMColor
    );
  }
}
